/** 検索用テキスト処理（仕様書 §13.2）。 */

/** NFKC正規化＋小文字化。全角英数字・半角カナの表記ゆれを吸収する。 */
export function normalize(s: string): string {
  return s.normalize('NFKC').toLowerCase();
}

export function buildSearchText(title: string, body: string): string {
  return normalize(title + '\n' + body);
}

/**
 * クエリを語に分割する。半角/全角空白区切りでAND、ダブルクォートでフレーズ。
 */
export function parseQuery(q: string): string[] {
  const terms: string[] = [];
  const re = /"([^"]*)"|(\S+)/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(q)) !== null) {
    const term = (m[1] ?? m[2] ?? '').replace(/　/g, ' ').trim();
    if (term) terms.push(normalize(term));
  }
  return terms;
}

export function matchesAll(searchText: string, terms: string[]): boolean {
  return terms.every((t) => searchText.includes(t));
}

/** 最初のマッチ周辺 ±60文字を抜き出す。マッチが無ければ先頭から。 */
export function excerpt(body: string, terms: string[], radius = 60): string {
  if (!body) return '';
  const norm = normalize(body);
  let at = -1;
  for (const t of terms) {
    const i = norm.indexOf(t);
    if (i >= 0 && (at < 0 || i < at)) at = i;
  }
  if (at < 0) return body.slice(0, radius * 2) + (body.length > radius * 2 ? '…' : '');
  const start = Math.max(0, at - radius);
  const end = Math.min(body.length, at + radius);
  return (start > 0 ? '…' : '') + body.slice(start, end) + (end < body.length ? '…' : '');
}
